import { useCallback, useState } from 'react';
import { toast } from 'react-hot-toast';

import taskService from '../../../services/TaskService';

const getTaskId = (task) => task.id || task._id;

export default function useTaskReminders({ filteredRows, selection, taskSource }) {
  const [isSendingReminders, setIsSendingReminders] = useState(false);

  const sendReminders = useCallback(
    async (sendSelected) => {
      const filteredTaskIds = filteredRows.map(getTaskId).filter(Boolean).map(String);
      // eslint-disable-next-line no-undef
      const filteredTaskIdSet = new Set(filteredTaskIds);
      const taskIds = sendSelected
        ? selection.map(String).filter((taskId) => filteredTaskIdSet.has(taskId))
        : filteredTaskIds;

      if (!taskIds.length) {
        toast('No tasks are available for a reminder');
        return;
      }

      setIsSendingReminders(true);
      try {
        const response = await taskService.sendTaskReminders(taskIds, taskSource);
        const { messagesSent = 0, nonAssignedTasksSkipped = 0 } = response?.data?.data || {};
        if (messagesSent) {
          toast.success(
            `${messagesSent} WhatsApp reminder${messagesSent === 1 ? '' : 's'} sent${
              nonAssignedTasksSkipped
                ? ` · ${nonAssignedTasksSkipped} non-Assigned task${nonAssignedTasksSkipped === 1 ? '' : 's'} skipped`
                : ''
            }`
          );
        } else {
          toast(
            'No reminders were sent. Only Assigned tasks are eligible, and recipients need a valid WhatsApp number.'
          );
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Could not send task reminders');
      } finally {
        setIsSendingReminders(false);
      }
    },
    [filteredRows, selection, taskSource]
  );

  return {
    isSendingReminders,
    sendAllReminders: useCallback(() => sendReminders(false), [sendReminders]),
    sendSelectedReminders: useCallback(() => sendReminders(true), [sendReminders])
  };
}
